import { GetPremiumCTA } from 'components/PremiumCTA/GetPremiumCTA';

import './ModuleLibrary.scss';
import { ModuleCard } from 'components/ModuleCard/ModuleCard';
import { useServices } from 'index';
import { useQuery } from '@tanstack/react-query';
import { ModuleOverview } from 'types/module';
import { ModuleLoaderCard } from 'components/ModuleCard/ModuleLoaderCard/ModuleLoaderCard';
import { useTranslation } from 'react-i18next';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useIsUserAdmin, useIsUserMember } from 'queryHooks/permissions';

export const ModuleLibrary = () => {
  const { t } = useTranslation();
  useSetPageTitle({
    title: t('LearningHub', { ns: 'learningHub' }),
  });

  const learningHubService = useServices().learningHubService;

  const moduleList = useQuery({ queryKey: ['learningHubModuleList'], queryFn: learningHubService.getModules, refetchOnWindowFocus: false });
  const isAdmin = useIsUserAdmin(true);
  const { data: isUserMember, isPending } = useIsUserMember();

  return (
    <>
      <div className='default-page-header'>
        <h1 className='page-title'>{t('LearningHub', { ns: 'learningHub' })}</h1>
      </div>
      <div className='modules-tab'>
        {!isPending && !isUserMember && <GetPremiumCTA />}
        <ModulesGrid modules={moduleList.data} isPending={moduleList.isPending} isAdmin={isAdmin.data ?? false} />
      </div>
    </>
  );
};

type ModulesGridProps = {
  modules: ModuleOverview[] | undefined;
  isPending: boolean;
  isAdmin: boolean;
};
const ModulesGrid = ({ modules, isPending, isAdmin }: ModulesGridProps) => {
  return (
    <div className='modules-grid'>
      {!isPending
        ? modules?.map((module) => <ModuleCard key={module.id} module={module} isAdmin={isAdmin} />)
        : Array.from(Array(10)).map((el, index) => <ModuleLoaderCard key={index} />)}
    </div>
  );
};
